<template>
    <div class="dataCenter">
        <!-- <div class="nav_box box-shadow">
            <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1" @click="profileData">数据概况</el-menu-item>
                <el-menu-item index="2" @click="traffic">流量分析</el-menu-item>
                <el-menu-item index="3" @click="trading">交易分析</el-menu-item>
                <el-menu-item index="4" @click="content">内容分析</el-menu-item>
                <el-menu-item index="5" @click="user">用户分析</el-menu-item>
            </el-menu>
        </div> -->
        <router-view></router-view>
    </div>
</template>

<script>
// import _ from 'lodash'
export default {
    name: 'dataCenter',
    data() {
        return {
            // activeIndex: '1'
        }
    },
    mounted() {
        // if (_.endsWith(this.$route.path, 'profileData')) {
        //     this.activeIndex = '1'
        // } else if (_.endsWith(this.$route.path, 'traffic')) {
        //     this.activeIndex = '2'
        // } else if (_.endsWith(this.$route.path, 'trading')) {
        //     this.activeIndex = '3'
        // } else if (_.endsWith(this.$route.path, 'content')) {
        //     this.activeIndex = '4'
        // } else if (_.endsWith(this.$route.path, 'contentGoodsInfo')) {
        //     this.activeIndex = '4'
        // } else if (_.endsWith(this.$route.path, 'user')) {
        //     this.activeIndex = '5'
        // }
    },
    methods: {
        // profileData() {
        //     this.$router.push({name: 'ProfileData'})
        // },
        // traffic() {
        //     this.$router.push({name: 'Traffic'})
        // },
        // trading() {
        //     this.$router.push({name: 'Trading'})
        // },
        // content() {
        //     this.$router.push({name: 'Content'})
        // },
        // user() {
        //     this.$router.push({name: 'User'})
        // }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.dataCenter {
    min-width: 1400px;
    .nav_box{
        background-color: #fff;
        // box-shadow:2px 0px 6px 0px rgba(0,21,41,0.14);
    }
    .el-menu.el-menu--horizontal {
        border-bottom: 1px solid #DCDFE6;
    }
    .el-menu--horizontal>.el-menu-item {
        height: 48px;
        line-height: 48px;
    }
    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
        color: #409EFF;
    }
    .el-menu-item {
        padding: 0 5px;
        margin: 0 15px!important;
    }
    .export_box{
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 0;
            height: 36px;
        }
        .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
            width: 240px;
        }
        .el-date-editor .el-range-separator {
            line-height: 28px;
        }
        &>div{
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            &>span{
                margin-right: 20px;
                width: 64px;
            }
        }
        &>div:nth-of-type(3){
            margin-bottom: 0px;
            align-items: flex-start;
            &>div {
                &>p {
                    margin-top: 20px;
                }
            }
        }
    }
}
.el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
}
.el-dialog {
    margin: 0px!important;
}
</style>
